// extracted by mini-css-extract-plugin
export default {"removedParentIssuesList":"ParentIssueRemovedEvent-module__removedParentIssuesList--DymD_","removedParentIssueItem":"ParentIssueRemovedEvent-module__removedParentIssueItem--I1cuJ"};